import { DateHelper } from "../util/dateHelper";
import { Log } from "../util/log";
import { RemoteHelper } from "../util/remoteHelper";
import { Deserializable } from "./deserializable";
import { DevicePilomatIO } from "./devicePilomatIO";
import { DeviceStateData } from "./deviceStateData";

export class LogEvent implements Deserializable {

  sender: string;
  type: string;
  data: string;
  date: Date;
  name: string;
  value: string = "";
  eventType: string;

  dataActive: string;
  dataType: string;
  dataTime: number;
  dataDate: Date;
  dataName: string;

  dateFriendly: string;

  stringCompleted = $localize`:@@log_event_completed:Completato`;
  stringOpenResult = $localize`:@@log_event_device_opened: Apertura dispositivo`;
  stringOpenIgnored = $localize`:@@log_event_device_open_ignored:Ignorata`;
  stringInternalError = $localize`:@@log_event_internal_error:Errore interno`;


  stringRemote = $localize`:@@log_event_remote:Radiocomando`;
  stringPlate = $localize`:@@log_event_plate:Targa`;
  stringPhoneNum = $localize`:@@log_event_phone:Numero di telefono`;
  stringBadge = $localize`:@@log_event_badge:Badge`;
  stringPinCode = $localize`:@@log_event_pincode:Codice PIN`;
  stringApp = $localize`:@@log_event_app:App`;

  stringForcedLow = $localize`:@@log_event_forced_low:Forzato basso`;

  stringRestartReasonUnkown = $localize`:@@log_event_restart_reason_unkown:Sconosciuto`;
  stringRestartReasonPowerOn = $localize`:@@log_event_restart_reason_power_on:Riavvio per mancanza di alimentazione`;
  stringRestartReasonExt = $localize`:@@log_event_restart_reason_ext:Resettato esternamente`;
  stringRestartReasonSw = $localize`:@@log_event_restart_reason_sw:Riavvio software`;
  stringRestartReasonPanic = $localize`:@@log_event_restart_reason_panic:Errore interno`;
  stringRestartReasonIntWdt = $localize`:@@log_event_restart_reason_int_wdt:Watchdog`;
  stringRestartReasonTaskWdt = $localize`:@@log_event_restart_reason_task_wdt:Watchdog`;
  stringRestartReasonWdt = $localize`:@@log_event_restart_reason_wdt:Watchdog`;
  stringRestartReasonDeepSleep = $localize`:@@log_event_restart_reason_deep_sleep:Riavvio da software`;
  stringRestartReasonBrownout = $localize`:@@log_event_restart_reason_brownout:Riavvio per mancanza di alimentazione`;
  stringRestartReasonSdio = $localize`:@@log_event_restart_reason_sdio:Riavvio da software`;

  static REASON_ESP_RST_UNKNOWN: string = "ESP_RST_UNKNOWN";
  static REASON_ESP_RST_POWERON: string = "ESP_RST_POWERON";
  static REASON_ESP_RST_EXT: string = "ESP_RST_EXT";
  static REASON_ESP_RST_SW: string = "ESP_RST_SW";
  static REASON_ESP_RST_PANIC: string = "ESP_RST_PANIC";
  static REASON_ESP_RST_INT_WDT: string = "ESP_RST_INT_WDT";
  static REASON_ESP_RST_TASK_WDT: string = "ESP_RST_TASK_WDT";
  static REASON_ESP_RST_WDT: string = "ESP_RST_WDT";
  static REASON_ESP_RST_DEEPSLEEP: string = "ESP_RST_DEEPSLEEP";
  static REASON_ESP_RST_BROWNOUT: string = "ESP_RST_BROWNOUT";
  static REASON_ESP_RST_SDIO: string = "ESP_RST_SDIO";

  deserialize(input: any) {

    Object.assign(this, input);


    if (this.type == "event") {

      let json = JSON.parse(this.data);

      this.dataType = json.type;
      this.dataTime = json.time;

      if (json.name !== null && json.name !== undefined && json.name != "" && json.name != " ") {
        this.dataName = json.name;
      } else {
        this.dataName = null;
      }
      this.value = json.value;

      if (this.dataType.startsWith("inp")) {
        this.dataActive = json.active;
      } else if (this.dataType.startsWith("sta")) {
        this.dataActive = this.value;
      }
      else if (this.dataType == "dat-temp") {

        this.name = $localize`:@@log_event_dat_temp:Sensore temperatura`;
        this.eventType = "value";
        this.value = $localize`:@@log_event_dat_temp_value:Temperatura rilevata: ` + json.value;
      }
    }
    else if (this.type == "gsmInfo") {
      this.eventType = "value";
      let json = JSON.parse(this.data);

      this.dataType = "gsmInfo"
      this.value = JSON.stringify(json.data);
      this.name = $localize`:@@log_event_gsm_info:Informazioni gsm`;
    }

    else if (this.type == "forcelow-changed") {
      this.eventType = "value";
      let json = JSON.parse(this.data);

      this.dataType = "forcelow-changed"
      if (json.active) {
        if (json.reason == "manual-forcelow") {
          this.value = $localize`:@@log_event_manual_forcelow_active:Forzato basso manuale attivato`;
        } else if (json.reason == "autom-forcelow") {
          this.value = $localize`:@@log_event_autom_forcelow_active:Forzato basso da automazione attivato`;
        } else if (json.reason == "disconnect-forcelow") {
          this.value = $localize`:@@log_event_disconnect_forcelow_active:Forzato basso da disconnessione attivato`;
        }
      } else {
        if (json.reason == "manual-forcelow") {
          this.value = $localize`:@@log_event_manual_forcelow_active_disabled:Forzato basso manuale disattivato`;
        } else if (json.reason == "autom-forcelow") {
          this.value = $localize`:@@log_event_autom_forcelow_active_disabled:Forzato basso da automazione disattivato`;
        } else if (json.reason == "disconnect-forcelow") {
          this.value = $localize`:@@log_event_disconnect_forcelow_active_disabled:Forzato basso da disconnessione disattivato`;
        }
      }
      this.name = $localize`:@@log_event_forcelow_changed:Aggiornamento stato forzato basso`;
    }

    //  "sender": "2500001",
    //  "type": "forcelow-changed",
    //  "data": "{\"active\":false,\"reason\":\"manual-forcelow\"}",
    //  "date": "202
    // 5-09-30 10:15:15Z"



    else if (this.type == "autom-deleted") {
      this.eventType = "event";
      let json = JSON.parse(this.data);

      this.dataType = "autom-deleted"
      this.value = JSON.stringify(json.data);
      this.name = $localize`:@@log_event_autom_deleted:Automazione eliminata`;
    } else if (this.type == "autom-updated") {
      this.eventType = "event";
      let json = JSON.parse(this.data);

      this.dataType = "autom-updated"
      this.value = JSON.stringify(json.data);
      this.name = $localize`:@@log_event_autom_deleted:Automazione eliminata`;
    }   // {
    //  "sender": "2500001",
    //  "type": "autom-deleted",
    //  "data": "{\"id\":109,\"sender\":\"2500001\",\"type\":\"autom-deleted\",\"data\":{\"number\":1}}",
    //  "date": "2025-09-30 10:14:46Z"
    // },


    else if (this.type == "open-result") {
      let json = JSON.parse(this.data);
      this.dataType = this.type;
      this.dataTime = json.time;
      this.value = json.value;
      this.name = this.stringOpenResult;
      this.eventType = "value";

      // if(this.isService()){

      // }

      if (json.result == "remote-err") {
        this.value = $localize`:@@log_event_opening_remote_error:Radiocomando non autorizzato` + " (" + RemoteHelper.jcmCodeToStandardCode(json.code) + " )";
      } else if (json.result == "license-plate-err") {
        this.value = $localize`:@@log_event_opening_licence_plate_error:Targa non autorizzata` + " (" + json.code + " )";
      } else if (json.result == "badge-err") {
        this.value = $localize`:@@log_event_opening_badge_error:Badge non autorizzato` + " (" + json.code + " )";
      } else if (json.result == "pincode-err") {
        this.value = $localize`:@@log_event_opening_pincode_error:Codice PIN non autorizzato`;
      } else if (json.result == "phone-err") {
        this.value = $localize`:@@log_event_opening_phone_error:Numero di telefono non autorizzato` + " (" + json.code + " )";
        // this.dataType = "phone-err";
      }

      else if (json.result == "opened" || json.result == "unauth" || json.result == "unauth-notfound") {

        if (json.result == "opened") {
          // "data": "{\"result\":\"opened\",\"way\":\"Badge0\",\"code\":\"602CF6\",\"time\":1710254503,\"client\":102}",
          this.value = $localize`:@@log_event_authorized_opening:Autorizzata`;

        } else if (json.result == "unauth") {
          // Unauth --> esiste l'access method, ma non é autorizzato --> "Non autorizzato, permessi insufficienti (Radiocomando <<codice>>)"
          this.value = $localize`:@@log_event_open-result_unauth:Non autorizzato, permessi insufficienti`;

        } else if (json.result == "unauth-notfound") {
          this.value = $localize`:@@log_event_open-result_unauth_not_found:Non autorizzato`;
          // unauth not found --> non esiste l'access method --> "Non autorizzato (Radiocomando <<codice>>)" (edited) 
        }

        if (json.way == "Remote") {
          this.value += " (" + this.stringRemote + " " + RemoteHelper.standardCodeToJcmCode(json.code) + ")";
        } else if (json.way == "Remote1C") {
          this.value += " (" + this.stringRemote + " " + json.code + ")";
        } else if (json.way == "Phone") {
          this.value += " (" + this.stringPhoneNum + " " + json.code + ")";
        } else if (json.way == "Badge" || json.way == "Badge0" || json.way == "Badge1") {
          this.value += " (" + this.stringBadge + " " + json.code + ")";
        } else if (json.way == "Pincode" || json.way == "Pincode0" || json.way == "Pincode1") {
          this.value += " (" + this.stringPinCode + ")";
        } else if (json.way == "App") {
          this.value += " (" + this.stringPinCode + ")";
        }

        // "data": "{\"result\":\"date-not-set\",\"way\":\"Phone\",\"code\":\"+393917475422\",\"time\":0,\"client\":102}",
      } else if (json.result == "date-not-set") {
        this.value = $localize`:@@log_event_date-not-set:Errore, data impianto non impostata`;
      }

      else {
        this.value = json.result;
      }
    }

    //open-ignored-XXX-not-enabled

    // "sender": "2300016",
    // "type": "open-ignored-remote-not-enabled",
    // "data": "{\"id\":17,\"sender\":\"2300016\",\"type\":\"open-ignored-remote-not-enabled\",\"data\":{\"time\":1727259993,\"way\":\"Remote\",\"code\":\"00262B37\"}}",
    // "date": "2024-09-25 10:26:37Z"

    else if (this.type == "open-ignored-remote-not-enabled") {
      this.eventType = "value";
      let json = JSON.parse(this.data);

      this.dataType = "open-ignored"
      this.value = this.stringOpenIgnored + " (" + this.stringRemote + " " + RemoteHelper.standardCodeToJcmCode(json.data.code) + ")";
      this.name = this.stringOpenResult;
    }

    else if (this.type == "open-ignored-phone-not-enabled") {
      this.eventType = "value";
      let json = JSON.parse(this.data);
      this.dataType = "open-ignored"
      this.value = this.stringOpenIgnored + " (" + this.stringPhoneNum + " " + JSON.stringify(json.data.code) + ")";
      this.name = this.stringOpenResult;
    }


    else if (this.type == "open-ignored-app-not-enabled") {
      this.eventType = "value";
      this.dataType = "open-ignored"
      this.value = this.stringOpenIgnored + " (" + this.stringApp + ")";
      this.name = this.stringOpenResult;
    }


    else if (this.type == "open-ignored-plate-not-enabled") {
      this.eventType = "value";
      let json = JSON.parse(this.data);
      this.dataType = "open-ignored"
      this.value = this.stringOpenIgnored + " (" + this.stringPlate + " " + JSON.stringify(json.data.code) + ")";
      this.name = this.stringOpenResult;
    }

    else if (this.type.startsWith("open-ignored-pin")) {
      this.eventType = "value";
      this.dataType = "open-ignored"
      this.value = this.stringOpenIgnored + " (" + this.stringPinCode + ")";
      this.name = this.stringOpenResult;
    }


    else if (this.type.startsWith("open-ignored-badge")) {
      this.eventType = "value";
      let json = JSON.parse(this.data);

      this.dataType = "open-ignored"
      this.value = this.stringOpenIgnored + " (" + this.stringBadge + " " + JSON.stringify(json.data.code) + ")";
      this.name = this.stringOpenResult;
    }


    // data:  "{\"id\":34,\"sender\":\"2300016\",\"type\":\"open-ignored-forced-low\",\"data\":{\"time\":1727337185,\"way\":\"Remote\",\"code\":\"00262B37\"}}"
    // date:  "2024-09-26 07:53:07Z"
    // sender : "2300016"
    // type : "open-ignored-forced-low"

    else if (this.type == "open-ignored-forced-low") {
      this.eventType = "value";
      let json = JSON.parse(this.data);
      this.dataType = "open-ignored"
      // this.value = this.stringOpenIgnored + " " + this.stringForcedLow;
      this.value = this.stringOpenIgnored + " (" + this.stringForcedLow + ")";

      this.name = this.stringOpenResult;
    }

    // data : "{\"id\":24,\"sender\":\"2300016\",\"type\":\"httpErr\",\"data\":{\"err\":\"cgi-1c-date\"}}"
    // date : "2024-09-26 15:08:55Z"
    // sender : "2300016"
    // type : "httpErr"

    else if (this.type == "httpErr") {
      this.eventType = "value";
      let json = JSON.parse(this.data);
      // let datajson  = JSON.parse(json.data);
      this.dataType = "httpErr"
      // this.value = this.stringOpenIgnored + " " + this.stringForcedLow;
      this.value = json.data.err;

      this.name = this.stringInternalError;
    }


    else {

      this.dataActive = "true";
      this.dataType = this.type;
    }
    if (this.dataType == "inp-ls") { //LOWERED_SWITCH
      this.eventType = "bool";
      this.name = $localize`:@@log_event_lower_switch: Switch basso`;
    } else if (this.dataType == "inp-lus") { //LIFTED_UP_SWITCH
      this.eventType = "bool";
      this.name = $localize`:@@log_event_upper_switch: Switch alto`;
    } else if (this.dataType == "inp-lup") { //LIFTED_UP_PRESSURE
      this.eventType = "bool";
      this.name = $localize`:@@log_event_high_pressure_switch: Switch alto pressione`;
    } else if (this.dataType == "inp-cs") { //CRASH_SENSOR
      this.eventType = "event";
      this.name = $localize`:@@log_event_crash_sensor: Crash sensor`;
    } else if (this.dataType == "inp-gb") { //GLASS_BREAKAGE
      this.eventType = "event";
      this.name = $localize`:@@log_event_glass_breakage: Glass breakage`;
    } else if (this.dataType == "inp-efo") { //EFO
      this.eventType = "event";
      this.name = $localize`:@@log_event_efo: EFO`;
    } else if (this.dataType == "inp-start") { //_START
      this.eventType = "event";
      this.name = $localize`:@@log_event_start: Start`;
    } else if (this.dataType == "inp-plow") { //PRESSURE_LOW
      this.eventType = "event";
      this.name = $localize`:@@log_event_low_pressure: Bassa pressione`;
    } else if (this.dataType == "inp-safe") { //SAFETY
      this.eventType = "event";
      this.name = $localize`:@@log_event_safety: Safety`;
    } else if (this.dataType == "inp-other") { //OTHER
      this.eventType = "event";

      this.name = $localize`:@@log_event_other_2:Altro`;

      // if (this.dataName === null || this.dataName === undefined) {
      // } else {
      //   this.name = $localize`:@@log_event_other:Altro:` + " " + this.dataName;
      // }

    } else if (this.dataType == "inp-door") {
      this.eventType = "event";
      this.name = DevicePilomatIO.EVENT_TYPE_SIGNAL_DOOR_OPEN_STRING;
    } else if (this.dataType == "inp-keyd") {
      this.eventType = "event";
      this.name = DevicePilomatIO.EVENT_TYPE_SIGNAL_KEY_LOCKDOWN_STRING;
    } else if (this.dataType == "inp-keyu") {
      this.eventType = "event";
      this.name = DevicePilomatIO.EVENT_TYPE_SIGNAL_KEY_LOCKUP_STRING;
    } else if (this.dataType == "inp-power") {
      this.eventType = "event";
      this.name = DevicePilomatIO.EVENT_TYPE_SIGNAL_POWER_SUPPLY_STRING;
    } else if (this.dataType == "inp-ups") {
      this.eventType = "event";
      this.name = DevicePilomatIO.EVENT_TYPE_SIGNAL_UPS_STRING;
    } else if (this.dataType == "inp-alpump") { //ALLARME POMPA IMMERSIONE
      this.eventType = "alarm";
      this.name = $localize`:@@log_event_alarm_pump:Allarme pompa immersione`;
    } else if (this.dataType == "err-pressupre-low") { //ERROR_PRESSURE_LOW
      this.eventType = "event";
      this.name = $localize`:@@log_event_low_pressure_error: Errore bassa pressione`;
    } else if (this.dataType == "err-safety") { //ERROR_SAFETY
      this.eventType = "event";
      this.name = $localize`:@@log_event_low_safety_error: Errore safety`;
    } else if (this.dataType == "err-glass-breakage") { //GLASS_BREAKAGE
      this.eventType = "event";
      this.name = $localize`:@@log_event_glass_breakage_error: Errore glass breakage`;
    } else if (this.dataType == "mqtt-connected") {
      this.eventType = "event";
      this.name = $localize`:@@log_event_bollard_connected_to_internet:Dissuasore connesso ad Internet`;
    } else if (this.dataType == "boot") {
      this.eventType = "event";
      this.name = $localize`:@@log_event_bollard_turned_on:Dissuasore acceso`;

      let json = JSON.parse(this.data);

      if (json.resetStr !== null && json.resetStr !== undefined) {
        this.eventType = "value";
        this.value = $localize`:@@log_event_previous_off_reason:Motivazione spegnimento precedente: `;
        if (json.resetStr == LogEvent.REASON_ESP_RST_UNKNOWN) {
          this.value += this.stringRestartReasonUnkown;
        } else if (json.resetStr == LogEvent.REASON_ESP_RST_POWERON) {
          this.value += this.stringRestartReasonPowerOn;
        } else if (json.resetStr == LogEvent.REASON_ESP_RST_EXT) {
          this.value += this.stringRestartReasonExt;
        } else if (json.resetStr == LogEvent.REASON_ESP_RST_SW) {
          this.value += this.stringRestartReasonSw;
        } else if (json.resetStr == LogEvent.REASON_ESP_RST_PANIC) {
          this.value += this.stringRestartReasonPanic;
        } else if (json.resetStr == LogEvent.REASON_ESP_RST_INT_WDT) {
          this.value += this.stringRestartReasonIntWdt;
        } else if (json.resetStr == LogEvent.REASON_ESP_RST_TASK_WDT) {
          this.value += this.stringRestartReasonTaskWdt;
        } else if (json.resetStr == LogEvent.REASON_ESP_RST_WDT) {
          this.value += this.stringRestartReasonWdt;
        } else if (json.resetStr == LogEvent.REASON_ESP_RST_DEEPSLEEP) {
          this.value += this.stringRestartReasonDeepSleep;
        } else if (json.resetStr == LogEvent.REASON_ESP_RST_BROWNOUT) {
          this.value += this.stringRestartReasonBrownout;
        } else if (json.resetStr == LogEvent.REASON_ESP_RST_SDIO) {
          this.value += this.stringRestartReasonSdio;
        }
      }


    } else if (this.dataType == "io-update") {
      this.eventType = "bool";
      this.name = $localize`:@@log_event_io_update_request:Richiesta aggiornamento I/O`;
    } else if (this.dataType == "io-updated") {
      this.eventType = "bool";
      this.name = $localize`:@@log_event_io_update_completed:Aggiornamento I/O completato`;
    } else if (this.dataType == "clients-update") {
      this.eventType = "bool";
      this.name = $localize`:@@log_event_users_update_request:Richiesta aggiornamento utenti`;
    } else if (this.dataType == "client-deleted") {
      this.eventType = "bool";
      this.name = $localize`:@@log_event_user_deleted:Utente eliminato`;
    } else if (this.dataType == "clients-updated") {
      this.eventType = "bool";
      this.name = $localize`:@@log_event_users_update_completed:Aggiornamento utenti completato`;
    } else if (this.dataType == "groups-update") {
      this.eventType = "bool";
      this.name = $localize`:@@log_event_groups_update_request:Richiesta aggiornamento gruppi`;
    } else if (this.dataType == "group-update") {
      this.eventType = "bool";
      this.name = $localize`:@@log_event_group_update_request:Richiesta aggiornamento gruppo`;
    } else if (this.dataType == "group-updated") {
      this.eventType = "bool";
      this.name = $localize`:@@log_event_group_update_completed:Aggiornamento gruppo completato`;
    } else if (this.dataType == "groups-updated") {
      this.eventType = "bool";
      this.name = $localize`:@@log_event_groups_update_completed:Aggiornamento gruppi completato`;
    } else if (this.dataType == "group-deleted") {
      this.eventType = "bool";
      this.name = $localize`:@@log_event_group_deleted:Gruppo eliminato`;
    } else if (this.dataType == "client-update") {
      this.eventType = "bool";
      this.name = $localize`:@@log_event_user_update_request:Richiesta aggiornamento utente`;
    } else if (this.dataType == "client-updated") {
      this.eventType = "bool";
      this.name = $localize`:@@log_event_user_update_completed:Aggiornamento utente completato`;
      // Adding "sta-" events
    } else if (this.dataType == "sta-cyup") {
      this.eventType = "value";
      this.dataActive = this.value;
      this.name = $localize`:@@log_event_raising_cycles_counter:Numero cicli risalita`;
    } else if (this.dataType == "sta-cydo") {
      this.eventType = "value";
      this.dataActive = this.value;
      this.name = $localize`:@@log_event_lowering_cycles_counter:Numero di cicli di abbassamento`;
    } else if (this.dataType == "sta-invp") {
      this.eventType = "value";
      this.dataActive = this.value;
      this.name = $localize`:@@log_event_pressure_invertions_counter:Numero di inversioni da pressione`;
    } else if (this.dataType == "sta-bol") {
      this.eventType = "value";
      this.dataActive = this.value;
      this.name = $localize`:@@log_event_bollards_counter:Numero di dissuasori`;
    } else if (this.dataType == "sta-tlow") {
      this.eventType = "value";
      this.dataActive = this.value;
      this.name = $localize`:@@log_event_lowering_timeouts_counter:Numero di timeout di abbassamento`;
    } else if (this.dataType == "sta-cyefo") {
      this.eventType = "value";
      this.dataActive = this.value;
      this.name = $localize`:@@log_event_lowering_efo_cycles_counter:Numero di cicli EFO`;
    } else if (this.dataType == "sta-invs") {
      this.eventType = "value";
      this.dataActive = this.value;
      this.name = $localize`:@@log_event_lowering_safety_invertions_counter:Numero di inversioni da Safety`;
    } else if (this.dataType == "sta-tris") {
      this.eventType = "value";
      this.dataActive = this.value;
      this.name = $localize`:@@log_event_lowering_raising_timeouts_counter:Numero di timeout di risalita`;
    } else if (this.dataType == "sta-dip") {
      this.eventType = "value";
      this.value = this.getDipSwitchState(this.value);
      this.name = $localize`:@@log_event_dip_switch_update:Aggiornamento DIP switch`;
      //adding errors
    } else if (this.dataType == "group-update-error") {
      this.eventType = "value";
      this.dataActive = "Errore";
      this.name = $localize`:@@log_event_group_update_error:Errore aggiornamento gruppo`;
    } else if (this.dataType == "client-update-error") {
      this.eventType = "value";
      this.dataActive = "Errore";
      this.name = $localize`:@@log_event_user_update_error:Errore aggiornamento utente`;
    } else if (this.dataType == "method-update-error") {
      this.eventType = "value";
      this.dataActive = "Errore";
      this.name = $localize`:@@log_event_access_method_update_error:Errore aggiornamento metodo d'accesso`;
    } else if (this.dataType == "canbusErr") {
      this.eventType = "value";
      this.dataActive = "Errore";
      this.name = $localize`:@@log_event_canbus_error:Errore canbus`;
      let json = JSON.parse(this.data);

      Log.debug("\n\n\n\n canbus errore:");
      Log.debug(json);

      this.value = json.data.err;
    } //deviceInfo
    else if (this.dataType == "deviceInfo") {
      this.name = $localize`:@@log_event_access_device_info_update:Aggiornamento informazioni dispositivo`;
      this.eventType = "value";
      this.value = this.stringCompleted;
    } else if (this.dataType == "forcelow-state") {
      let json = JSON.parse(this.data);

      if (json.active == true || json.active == false) {
        this.eventType = "bool";
        this.dataActive = json.active;
      } else {
        this.eventType = "value";
        this.value = "-";
      }
      this.name = $localize`:@@log_event_access_device_forcelow_state:Stato forzato basso`;
    } else if (this.dataType == "device-online") {
      this.name = $localize`:@@log_event_access_device_online:Dispositivo connesso ad internet`;
      this.eventType = "event";
    } else if (this.dataType == "device-offline") {
      this.name = $localize`:@@log_event_access_device_offline:Dispositivo disconnesso da internet`;
      this.eventType = "event";
    } else if (this.dataType == "forcelow-timeout") {
      this.name = $localize`:@@log_event_forcelow_timeout:Timeout comando forzato basso`;
      this.eventType = "event";
    } else if (this.dataType == "router") {
      this.name = $localize`:@@log_event_router_data_update:Informazioni router aggiornate`;
      this.eventType = "value";;
      let json = JSON.parse(this.data);
      let routerInfo = JSON.stringify(json.data.info).split(",");
      let routerSerial = $localize`:@@log_event_router_serial:Seriale router: `;
      this.value = routerSerial + routerInfo[3];
    }

    this.date = DateHelper.parseDate(input.date);
    this.dateFriendly = DateHelper.formatDateTimeFriendly(this.date);

    if (this.dataName !== undefined && this.dataName !== null) {
      this.name += ": " + this.dataName;
    }

    return this;
  }

  // public getDescription(): string {

  //   if (this.dataType == "mqtt-connected") {
  //     return "Dissuasore connesso ad Internet";
  //   } if (this.dataType == "boot") {
  //     return "Dissuasore acceso";
  //   } else {
  //     return this.dataType;
  //   }
  // }

  public getIcon(): string {

    if (this.dataType == "mqtt-connected") {
      return "wifi";
    } else if (this.dataType.includes("error")) {
      return "exclamation-circle";

    } else if (this.dataType == "httpErr" || this.dataType == "inp-alpump") {
      return "exclamation-circle";
    }
    else if (this.dataType.includes("client")) {
      return "user";
    }
    else if (this.dataType.includes("group")) {
      return "users";
    }

    else if (this.dataType == "boot") {
      return "bolt";

    } else if (this.dataType == "device-offline" || this.dataType == "device-online") {
      return "power-off";

    } else if (this.dataType == "mqtt-connected") {
      return "network-wired";
    } else if (this.dataType == "dat-temp") {
      return "thermometer-half";
    }

    if (this.type == "event") {
      if (this.dataActive) {
        return "dot-circle";
      }
      else {
        return "circle";
      }
    } if (this.type.startsWith("open-ignored")) {
      return "ban";
    }
    else {
      return "comment";
    }

  }

  public getDipSwitchState(dipSwitchvalue: string): string {
    let dipSwitchesState: Boolean[] = [false, false, false, false, false, false];
    let dipSwitchesStateString: string[] = ["", "", "", "", "", ""];
    let dipSwitchStateBinary = Number(dipSwitchvalue).toString(2);

    if (dipSwitchStateBinary.length == 6) {
      dipSwitchesState[5] = true;
      dipSwitchesStateString[5] = "ON";
    } else {

      if (dipSwitchStateBinary.length == 4) {
        dipSwitchStateBinary = "0".concat(dipSwitchStateBinary);
      } else if (dipSwitchStateBinary.length == 3) {
        dipSwitchStateBinary = "00".concat(dipSwitchStateBinary);
      } else if (dipSwitchStateBinary.length == 2) {
        dipSwitchStateBinary = "000".concat(dipSwitchStateBinary);
      } else if (dipSwitchStateBinary.length == 1) {
        dipSwitchStateBinary = "0000".concat(dipSwitchStateBinary);
      }

      for (let i = 0; i < 5; i++) {
        if (dipSwitchStateBinary.charAt(i) == "1") {
          dipSwitchesState[4 - i] = false;
          dipSwitchesStateString[4 - i] = "OFF";

        } else {
          dipSwitchesState[4 - i] = true;
          dipSwitchesStateString[4 - i] = "ON";
        }
      }
      dipSwitchesState[5] = false;
      dipSwitchesStateString[5] = "OFF";
    }
    let returnString = "AUTO: " + dipSwitchesStateString[0] + " | INP: " + dipSwitchesStateString[1] + " | LOOP: " + dipSwitchesStateString[2] + " | PR1: " + dipSwitchesStateString[3] + " | PR2: " + dipSwitchesStateString[4] + " | SERVICE: " + dipSwitchesStateString[5];

    return returnString;
  }

}


